import { NgModule } from '@angular/core';
import { ThemeModule } from '../../@theme/theme.module';
import { ParametreComponent } from './parametre.component';
import { ParamUtilisateurComponent } from './param-utilisateur/param-utilisateur.component';
import { ParamTacheComponent } from './param-tache/param-tache.component';

@NgModule({
  imports: [
    ThemeModule,
  ],
  declarations: [
    ParametreComponent,
    ParamUtilisateurComponent,
    ParamTacheComponent,
  ],
})
export class ParamModule { }
